import { Badge } from '@kollektive/design-system';
import type { ConnectionTypeDefinition } from './connectionTypeRegistry';
import styles from './ConnectionTypeCard.module.css';

interface ConnectionTypeCardProps {
  type: ConnectionTypeDefinition;
  onClick: (type: ConnectionTypeDefinition) => void;
}

export function ConnectionTypeCard({ type, onClick }: ConnectionTypeCardProps) {
  const isDisabled = type.status === 'coming_soon';

  return (
    <button
      className={`${styles.card} ${isDisabled ? styles.disabled : ''}`}
      onClick={() => !isDisabled && onClick(type)}
      disabled={isDisabled}
      type="button"
    >
      <div className={styles.iconWrapper} style={{ backgroundColor: `${type.color}15` }}>
        <type.icon size={24} style={{ color: type.color }} />
      </div>
      <div className={styles.content}>
        <div className={styles.nameRow}>
          <span className={styles.name}>{type.name}</span>
          {type.status === 'new' && (
            <Badge variant="info" size="sm">New</Badge>
          )}
          {type.status === 'coming_soon' && (
            <Badge variant="neutral" size="sm">Coming Soon</Badge>
          )}
        </div>
        <p className={styles.description}>{type.description}</p>
      </div>
    </button>
  );
}
